// libraries
import type { DealHistory, StateTree } from '@makemydeal/dr-dash-types';

export const getQuickCompareOffer = (state: StateTree): DealHistory => state.quickCompare;
